<template>
  <div class="ui-message">
    <div class="ui-message__content">
      <div class="ui-message__title">
        <slot name="title"></slot>
      </div>
      <div class="ui-message__message">
        <slot name="message"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  // import Translations from "./insert-me-to-translate.vue";

  export default {
    data() {
      return {}
    },
  }
</script>

<style>
  .ui-message {
    padding: 20px 8px;
    border-radius: 8px;
    border: 1px solid var(--color-gray-7);
    background: var(--color-gray-10);
    width: 100%;
    height: auto;
  }
  .ui-message__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: stretch;
    gap: 10px;
    text-align: center;
  }
  .ui-message__title {
    color: var(--color-dark);
    font-size: var(--font-size-medium);
    font-weight: 600;
  }
  .ui-message__message {
    color: var(--color-message);
    font-size: var(--font-size-small-medium);
    font-weight: 400;
  }
</style>
